<template>
    <div class = "selectPlan">
        <!-- <bannerDialog
            v-if="step === 1"
            :closeBanner = "closeBanner"
            @closeDialog="closeDialog"
            class = "mb-10"
        /> -->
        <div>
            <div v-if = "step === 1" class="widthButton backButtonOne mb-30">
                <img class = "back_image" src = "/img/arrow_back.svg" @click="success"/>
                <div class = "planContainer">
                    <p class = "selectPlanText">Select Plan</p>
                </div>
            </div>
            <planSelection
                v-if="step === 1"
                @selectPlan="selectPlan"
            />
            <div class = "mainContainer">
                <div style = "width: 100%;" v-if = "step === 2 && showBack" class="widthButton backButtonOne mb-20 mt-0">
                    <button class="btn-back btn w-45px" @click="goBack">
                        <v-icon class="material-icons-round"> arrow_back </v-icon>
                    </button>
                </div>
                <PlanCard
                    v-if = "step === 2 && showBack"
                    :portfolio="portfolio"/>
                <PaymentComponent
                    v-if="step === 2"
                    @goBack="goBack"
                    @success = "success"
                    :selectedPortfolio="portfolio"
                    :transactionPurpose = "'portfolioDirect'"
                    :showEscrow="false"
                    :hideBankTransfer="false"
                    :disableAmountField="disableAmountField"
                    :hideMinimumInvest="hideMinimumInvest"
                    :customProps = "customProps"
                    :isFirstTime = "false"
                    />
            </div>
        </div>
    </div>
</template>

<script>
import planSelection from '@/components/common/selectPlan.vue'
import PaymentComponent from '@/components/common/paymentComponent/paymentComponent.vue'
import LenderService from '@/services/lenderService'
import PlanCard from '@/components/common/planCard/planCardNew.vue'
// import bannerDialog from '@/components/common/bannerDialog.vue'
export default {
    name: 'SelectPlan',
    components: {
        planSelection,
        PaymentComponent,
        PlanCard
        // bannerDialog
    },
    data () {
        return {
            step: 1,
            showBack: true,
            selectedPortfolio: null,
            portfolio: {},
            hideMinimumInvest: true,
            disableAmountField: false,
            customProps: {
                hideBackButton: true
            },
            closeBanner: true
        }
    },
    mounted () {
        if (this.$route.query?.txnid) {
            this.step = 2
            this.showBack = false
            setTimeout(() => {
                this.$router.push('/dashboard')
            }, 4000)
        }
    },
    methods: {
        closeDialog () {
            this.closeBanner = false
        },
        success () {
            this.$router.push('/dashboard')
        },
        goBack () {
            this.step--
        },
        selectPlan (planName) {
            this.selectedPortfolio = planName
            this.checkIfPlanExists()
        },
        checkIfPlanExists () {
            this.$store.commit('isLoading')
            const query = 'portfolio=' + this.selectedPortfolio
            LenderService.checkIfPortfolioExists(query).then((res) => {
                this.$store.commit('isNotLoading')
                if (res.status === 200) {
                    if (res.data?.riskProfile) {
                        this.portfolio.portfolioId = res.data._id
                        this.portfolio.riskProfile = res.data.riskProfile
                        this.portfolio.planType = res.data.planType
                        this.portfolio.investmentAmount = 0
                        if (res.data?.investmentAmount) {
                            this.portfolio.investmentAmount += res.data.investmentAmount
                            // this.portfolio.pendingInvestmentAmount = res.data.pendingInvestmentAmount
                        }
                        if (res.data.pendingInvestmentAmount) {
                            this.portfolio.investmentAmount += res.data.pendingInvestmentAmount
                        }
                        this.step++
                    } else {
                        this.createPortFolio()
                    }
                }
            })
        },
        createPortFolio () {
            this.$store.commit('isLoading')
            const payload = {
                portfolio: this.selectedPortfolio
            }
            LenderService.createNewPortfolio(payload).then((res) => {
                this.$store.commit('isNotLoading')
                if (res.status === 200) {
                    this.portfolio.portfolioId = res.data._id
                    this.portfolio.riskProfile = res.data.riskProfile
                    this.portfolio.planType = res.data.planType
                    if (res.data?.investmentAmount) {
                        this.portfolio.investmentAmount = res.data.investmentAmount
                    } else {
                        this.portfolio.investmentAmount = 0
                    }
                    this.step++
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "~@/sass/components/registration-flow.scss";
@import "@/components/dashboard/dashboard.scss";

    .back_image {
        cursor: pointer;
    }
    .mainContainer {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .selectPlan {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 40px;
        padding-bottom: 40px
    }
    .selectPlanText {
        font-weight: 800;
        font-size: 21px;
        margin-left: 15px;
        margin-bottom: 0px;
    }
    .widthButton {
        margin-top: 0px;
        max-width: 320px;
        min-width: 300px;
        display: flex;
        flex-direction: row;
    }
    .planContainer {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

</style>
